import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { handleError } from "../shared/util/error-util";
import { TipoExecucao } from "./resultado-regra/tipo-execucao";
import { CarteiraAutocompleteMapper } from '../shared/components/carteira-autocomplete/carteira-autocomplete.mapper';

@Injectable({
  providedIn: 'root'
})
export class ResultadoRegraService {

  private readonly url = '/v1/resultados';
  private readonly _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(
    private readonly datePipe: DatePipe,
    private readonly httpClient: HttpClient,
    private readonly carteiraAutocompleteMapper: CarteiraAutocompleteMapper
  ) {
  }

  search(value: any, pageSize = 20): Observable<any> {
    const headers = this._httpHeaders;
    let params = this.createFormParam(value);
    params = params.set("size", pageSize + '');
    params = params.set("page", value.page);


    const options = {headers, params};
    return this.httpClient.get<any>(`${this.url}/detalhes`, options);
  }

  searchDetailProcess(carteiraId: number, dataInicio: Date, dataFim: Date, pageSize = 20, page: number): Observable<any> {

    const headers = this._httpHeaders;
    let params
    params = this.createFormParamDetailProcess(carteiraId, dataInicio, dataFim);
    params = params.set("size", pageSize + '');
    params = params.set("page", page);

    const options = {headers, params};
    return this.httpClient.get<any>(`${this.url}/detalhes-processamento`, options);
  }

  lastTenProccess(carteiraId: number): Observable<any> {
    const headers = this._httpHeaders;
    let params
    params = this.createFormParamlastTenProcess(carteiraId);

    const options = {headers, params};
    return this.httpClient.get<any>(`${this.url}/ultimos-dez-processamentos`, options);
  }

  exportPdf(value: any): Observable<HttpResponse<Blob>> {
    const headers = this._httpHeaders;
    const params = this.createFormParam(value).set("size", '99999999');
    return this.httpClient.get(`${this.url}/export/pdf`, {
      headers,
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }

  exportXlsx(value: any): Observable<HttpResponse<Blob>> {
    const headers = this._httpHeaders;
    const params = this.createFormParam(value).set("size", '99999999');
    return this.httpClient.get(`${this.url}/export/xlsx`, {
      headers,
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }

  exportComposicaoCarteira(id: number): Observable<HttpResponse<Blob>> {
    const headers = this._httpHeaders;
    return this.httpClient.get(`${this.url}/${id}/composicao-carteira/export/xls`, {
      headers,
      responseType: "blob",
      observe: "response",
    }).pipe(catchError(handleError));
  }


  private createFormParam(value: any) {

    let params: HttpParams = new HttpParams();
    this.carteiraAutocompleteMapper.map(value);

    if (value.carteiraId) {
      params = params.set('carteiraId', value.carteiraId);
    }
    if (value.grupoCarteiraId) {
      params = params.set('grupoCarteiraId', value.grupoCarteiraId)
    }
    if (value.regra) {
      params = params.set('regraId', value.regra);
    }
    if (value.dataInicio) {
      params = params.set('dataInicio', this.datePipe.transform(value.dataInicio, 'yyyy-MM-dd'));
    }
    if (value.dataFim) {
      params = params.set('dataFim', this.datePipe.transform(value.dataFim, 'yyyy-MM-dd'));
    }
    if (value.status !== null && value.status !== '') {
      params = params.set('status', value.status);
    }
    if (value.tiposExecucao !== null && value.tiposExecucao !== '') {
      params = params.set('tipoExecucao', value.tiposExecucao);
    }
    params = params.set('ativaUltimaDataProcessamento', value.ativaUltimaDataProcessamento);

    params = this.sortParams(params);

    return params;
  }

  private createFormParamDetailProcess(carteiraId, dataInicio, dataFim) {

    let params: HttpParams = new HttpParams();

    if (carteiraId) {
      params = params.set('carteiraId', carteiraId);
    }
    if (dataInicio) {
      params = params.set('dataInicio', this.datePipe.transform(dataInicio, 'yyyy-MM-dd'));
    }
    if (dataFim) {
      params = params.set('dataFim', this.datePipe.transform(dataFim, 'yyyy-MM-dd'));
    }
    params = params.set('tipoExecucao', TipoExecucao.POSFATO.id);

    params = this.sortParams(params);

    return params;
  }

  private createFormParamlastTenProcessDashboard(value: any) {

    let params: HttpParams = new HttpParams();

    params = params.set('carteiraId', value.carteira.id);

    params = params.set('tipoExecucao', TipoExecucao.POSFATO.id);

    return params;
  }

  private createFormParamlastTenProcess(carteiraId: number) {

    let params: HttpParams = new HttpParams();
    params = params.set('carteiraId', carteiraId.toString());

    params = params.set('tipoExecucao', TipoExecucao.POSFATO.id);

    return params;
  }

  public sortParams(params: HttpParams) {
    params = params.set("sort", "carteira.nome,ASC");
    params = params.append("sort", "dataEnquadramento,DESC");
    params = params.append("sort", "resultadoExecucaoCarteira.timeStamp,DESC");
    params = params.append("sort", "status,ASC");
    params = params.append("sort", "regra.nome,ASC");
    return params;
  }
}
